import MDBox from "../../../components/MDBox";
import pxToRem from "../../../assets/theme/functions/pxToRem";
import {memo, useCallback, useEffect, useState} from "react";
import {showMessage, useApi} from "../../../services/helpers";
import MDTypography from "../../../components/MDTypography";
import {DoneText, NewPMButton} from "./styles";
import {Icon} from "@mui/material";
import CustomerCell from "../../../layouts/ecommerce/orders/order-list/components/CustomerCell";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import debounce from "lodash.debounce";
import AddBaseModal from "../../../components/add-base-modal/AddBaseModal";
import {ROLES} from "../../../services/constants";
import ConfirmDialogModal from "../../../components/ConfirmDialogModal";


export const AddSubContractorModal = memo(({open, item, onClose, loading, onUpdate}) => {
  const api = useApi()
  const [subContractorReps, setSubContractorReps] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [selectedSubContractorRepsId, setSelectedSubContractorRepsId] = useState(item?.sub_contractor_reps.map((item) => item.id) || [])
  const [openModal, setOpenModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)


  useEffect(() => {
    getManagers({search: ""})
  }, [])

  const getManagers = ({search}) => {
    api.getAllUsers({
      search: search,
      page: 1,
      ordering: '',
      page_size: 25,
      role: ROLES.SUB_CONTRACTOR_REP.name,
      sub_contractor_reps: item?.id
    }).then((result) => {
      if (result.kind === 'ok') {
        setSubContractorReps(result?.data?.results)
      }
    }).catch(reason => console.log(reason))
  }

  const searchUser = (value) => {
    getManagers({search: value})
  }

  const debouncedInputChange = useCallback(
    debounce(searchUser, 300)
    , [])

  const addSubContractorsRep = () => {
    api.addSubContractorsRep({id: item.id, sub_contractor_rep: selectedUser.id}).then((result) => {
      if (result.kind === 'ok') {
        showMessage('Sub Contractor Rep updated successfully', 'success')
        setOpenModal(false)
        if (selectedSubContractorRepsId?.includes(selectedUser?.id)) {
          const newArray = selectedSubContractorRepsId.filter(function(item) {
            return item !== selectedUser.id
          })
          setSelectedSubContractorRepsId(newArray)
        } else {
          setSelectedSubContractorRepsId([...selectedSubContractorRepsId, selectedUser.id])
        }
        onUpdate()
      } else {
        showMessage()
      }
    })
      .catch(err => showMessage(err))
  }

  return (
    <AddBaseModal
      open={open}
      loading={loading}
      handleClose={() => {
        onClose()
      }}
      title={'Update Sub-Contractors'}
      headerContent={
        <MDTypography
          variant='h6'
          sx={DoneText}
          onClick={() => onClose()}
        >
          Done
        </MDTypography>
      }
      showActions={false}
      modalContainer={{height: pxToRem(820)}}
    >
      <ConfirmDialogModal
        title={'Do you want to change the current sub-contractor rep?'}
        description={``}
        cancelText={'Cancel'}
        confirmText={'Confirm'}
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={() => addSubContractorsRep()}
      />

      <MDBox padding={`${pxToRem(20)} ${pxToRem(24)}`} overflow={'auto'}>
        <MDInput
          sx={{width: '100%'}}
          placeholder={'Search for sub-contractor reps'}
          value={searchValue}
          onChange={(e) => {
            debouncedInputChange(e.target.value)
            setSearchValue(e.target.value);
          }}
          InputProps={{
            endAdornment:
              <Icon fontSize='medium' sx={({palette: {icons}}) => ({color: icons.search_icon})}>
                search
              </Icon>
          }}
        />
        <MDBox display='flex' flexDirection='column' gap={pxToRem(28)}>
          {!subContractorReps.length
            ? <MDBox height={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <MDTypography variant='subtitle2'>No sub-contractor reps found</MDTypography>
              </MDBox>
            : subContractorReps.map(user => {
            return (
            <MDBox key={user.id} border='none' display='flex' justifyContent='space-between' alignItems='center'>
              <CustomerCell
                name={user.name}
                image={user.profile_picture}
                color={user.color || "dark"}
                styles={{fontSize: '1rem'}}
              />
              <MDButton
                variant={"outlined"}
                color={selectedSubContractorRepsId?.includes(user.id) ? "error" : "secondary"}
                onClick={() => {
                  if (selectedSubContractorRepsId?.id !== user.id) {
                    setOpenModal(true)
                    setSelectedUser(user)
                  }
                }}
                sx={NewPMButton}
              >
                {selectedSubContractorRepsId?.includes(user.id)  ? 'Remove' : 'Add'}
              </MDButton>
            </MDBox>
          )})}
        </MDBox>
      </MDBox>
    </AddBaseModal>
  )
})
